import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e8d5982"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "InvoiceDocument" }
const _hoisted_2 = { class: "InvoiceDocument__header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "header__logo",
  viewBox: "0 0 165 76",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M38.0879 57.6154C34.3215 57.6154 31.1597 56.8206 28.6027 55.2311C26.0802 53.6416 24.3007 51.4301 23.264 48.5966L31.1943 43.9836C32.5419 47.1972 34.9262 48.804 38.3471 48.804C41.1805 48.804 42.5973 47.9919 42.5973 46.3679C42.5973 45.3313 41.7852 44.4674 40.1612 43.7763C39.6083 43.569 38.0879 43.1025 35.6 42.3768C32.0754 41.3748 29.3974 39.9753 27.5661 38.1785C25.7347 36.3816 24.819 33.9974 24.819 31.0257C24.819 27.6739 26.0111 24.9614 28.3954 22.8881C30.8487 20.8148 33.855 19.7782 37.4141 19.7782C40.4549 19.7782 43.1501 20.5039 45.4998 21.9551C47.8495 23.3719 49.6464 25.4106 50.8903 28.0713L43.1156 32.6325C41.9753 29.9372 40.0921 28.5896 37.4659 28.5896C36.3947 28.5896 35.5654 28.8142 34.978 29.2634C34.3906 29.6781 34.0969 30.2482 34.0969 30.9739C34.0969 31.7686 34.5115 32.4424 35.3408 32.9953C36.2047 33.5482 37.8633 34.1874 40.3167 34.9131C42.148 35.4659 43.5648 35.9497 44.5669 36.3644C45.7072 36.8481 46.882 37.5047 48.0914 38.334C50.6139 39.9926 51.8751 42.636 51.8751 46.2642C51.8751 49.8233 50.6139 52.605 48.0914 54.6091C45.5689 56.6133 42.2344 57.6154 38.0879 57.6154ZM71.1027 30.1964C74.5581 30.1964 77.4434 31.5095 79.7586 34.1356C82.1083 36.7617 83.2831 40.0099 83.2831 43.88C83.2831 47.7501 82.1083 51.0155 79.7586 53.6762C77.4089 56.2677 74.5236 57.5635 71.1027 57.5635C67.9582 57.5635 65.5048 56.5269 63.7426 54.4536V67.2042H55.1385V30.922H63.7426V33.3063C65.5048 31.233 67.9582 30.1964 71.1027 30.1964ZM65.2457 47.9747C66.2478 49.0113 67.5608 49.5296 69.1849 49.5296C70.809 49.5296 72.122 49.0113 73.1241 47.9747C74.1262 46.9035 74.6272 45.5386 74.6272 43.88C74.6272 42.2213 74.1262 40.8564 73.1241 39.7853C72.122 38.7486 70.809 38.2303 69.1849 38.2303C67.5608 38.2303 66.2478 38.7486 65.2457 39.7853C64.2436 40.8564 63.7426 42.2213 63.7426 43.88C63.7426 45.5386 64.2436 46.9035 65.2457 47.9747ZM105.324 33.3063V30.922H113.928V56.8379H105.324V54.4536C103.561 56.5269 101.108 57.5635 97.9636 57.5635C94.4736 57.5635 91.5711 56.2677 89.2559 53.6762C86.9408 51.05 85.7832 47.7846 85.7832 43.88C85.7832 39.9408 86.9408 36.6926 89.2559 34.1356C91.5711 31.5095 94.4736 30.1964 97.9636 30.1964C101.108 30.1964 103.561 31.233 105.324 33.3063ZM95.9422 47.9747C96.9097 49.0113 98.2228 49.5296 99.8814 49.5296C101.54 49.5296 102.853 49.0113 103.821 47.9747C104.823 46.9035 105.324 45.5386 105.324 43.88C105.324 42.2213 104.823 40.8564 103.821 39.7853C102.853 38.7486 101.54 38.2303 99.8814 38.2303C98.2228 38.2303 96.9097 38.7486 95.9422 39.7853C94.9401 40.8564 94.4391 42.2213 94.4391 43.88C94.4391 45.5386 94.9401 46.9035 95.9422 47.9747ZM127.52 30.922V35.7424C128.004 34.0838 128.954 32.788 130.371 31.855C131.822 30.8875 133.463 30.4037 135.295 30.4037V39.9408C133.325 39.6298 131.528 39.9926 129.904 41.0292C128.315 42.0659 127.52 43.759 127.52 46.1087V56.8379H118.916V30.922H127.52ZM155.089 43.88L164.16 56.8379H154.519L147.159 45.7977V56.8379H138.555V20.5557H147.159V41.7549L153.846 30.922H163.797L155.089 43.88Z",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    width: "10.3307",
    height: "64.5668",
    fill: "#8BC514"
  })
], -1))
const _hoisted_4 = { class: "header__terminals" }
const _hoisted_5 = { class: "terminals__terminal" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "terminal__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Жөнелту терминалы /"),
  /*#__PURE__*/_createElementVNode("span", null, "Терминал отправления")
], -1))
const _hoisted_7 = { class: "terminal__cells" }
const _hoisted_8 = { class: "cells__cell" }
const _hoisted_9 = { class: "cells__cell" }
const _hoisted_10 = { class: "cells__cell" }
const _hoisted_11 = { class: "terminals__terminal terminal--receive" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "terminal__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Қабылдау терминалы /"),
  /*#__PURE__*/_createElementVNode("span", null, "Терминал получения")
], -1))
const _hoisted_13 = { class: "terminal__cells" }
const _hoisted_14 = { class: "cells__cell" }
const _hoisted_15 = { class: "cells__cell" }
const _hoisted_16 = { class: "cells__cell" }
const _hoisted_17 = { class: "header__barcode" }
const _hoisted_18 = { class: "barcode__image" }
const _hoisted_19 = ["id", "data-value", "src"]
const _hoisted_20 = { class: "barcode__invoice-number" }
const _hoisted_21 = { class: "invoice-number__value" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invoice-number__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Жүкқұжат нөмірі /"),
  /*#__PURE__*/_createElementVNode("span", null, "Номер накладной")
], -1))
const _hoisted_23 = { class: "header__numbers" }
const _hoisted_24 = { class: "numbers__order-number" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-number__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Тапсырыc нөмiрi /"),
  /*#__PURE__*/_createElementVNode("span", null, "Номер заказа")
], -1))
const _hoisted_26 = { class: "order-number__value" }
const _hoisted_27 = { class: "numbers__customer-number" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-number__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Тапсырыс берушiнiң жүк құжат нөмiрi /"),
  /*#__PURE__*/_createElementVNode("span", null, "Номер накладной заказчика")
], -1))
const _hoisted_29 = { class: "customer-number__value" }
const _hoisted_30 = { class: "header__shipment-type" }
const _hoisted_31 = { class: "shipment-type__checkboxes" }
const _hoisted_32 = { class: "checkboxes__checkbox" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox__label" }, "Стандарт", -1))
const _hoisted_34 = { class: "checkboxes__checkbox" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox__label" }, "Опасный груз", -1))
const _hoisted_36 = { class: "checkboxes__checkbox" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox__label" }, "Экспресс", -1))
const _hoisted_38 = { class: "checkboxes__checkbox" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox__label" }, "Температурный режим", -1))
const _hoisted_40 = { class: "checkboxes__checkbox" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox__label" }, "Проекты", -1))
const _hoisted_42 = { class: "checkboxes__input" }
const _hoisted_43 = { class: "checkboxes__checkbox" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox__label" }, "Батарея", -1))
const _hoisted_45 = { class: "checkboxes__checkbox" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox__label" }, "Автозапчасти", -1))
const _hoisted_47 = { class: "InvoiceDocument__content" }
const _hoisted_48 = { class: "content__row" }
const _hoisted_49 = { class: "content__row" }
const _hoisted_50 = { class: "content__block template block--border-default" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Жіберуші / Отправитель")
], -1))
const _hoisted_52 = { class: "content__value value--small" }
const _hoisted_53 = { class: "content__block template block--border-default" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Алушы / Получатель")
], -1))
const _hoisted_55 = { class: "content__value value--small" }
const _hoisted_56 = { class: "content__row" }
const _hoisted_57 = { class: "content__block template-address block--border-default" }
const _hoisted_58 = { class: "template-address__column" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Мекен-жайы / Адрес")
], -1))
const _hoisted_60 = { class: "content__value value--small" }
const _hoisted_61 = { class: "template-address__column" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Сектор /"),
  /*#__PURE__*/_createElementVNode("span", null, "Сектор")
], -1))
const _hoisted_63 = { class: "content__value" }
const _hoisted_64 = { class: "content__block template-address block--border-default" }
const _hoisted_65 = { class: "template-address__column" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Мекен-жайы / Адрес")
], -1))
const _hoisted_67 = { class: "content__value value--small" }
const _hoisted_68 = { class: "template-address__column" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Сектор /"),
  /*#__PURE__*/_createElementVNode("span", null, "Сектор")
], -1))
const _hoisted_70 = { class: "content__value" }
const _hoisted_71 = { class: "content__row" }
const _hoisted_72 = { class: "content__block template-building block--border-default" }
const _hoisted_73 = { class: "template-building__column" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Үй / Ғимарат"),
  /*#__PURE__*/_createElementVNode("span", null, "Дом / Здание")
], -1))
const _hoisted_75 = { class: "content__value" }
const _hoisted_76 = { class: "template-building__column" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Пәтер / Кеңсе"),
  /*#__PURE__*/_createElementVNode("span", null, "Кв / Офис")
], -1))
const _hoisted_78 = { class: "content__value" }
const _hoisted_79 = { class: "template-building__column" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Индекс /"),
  /*#__PURE__*/_createElementVNode("span", null, "Индекс")
], -1))
const _hoisted_81 = { class: "content__value" }
const _hoisted_82 = { class: "content__block template-building block--border-default" }
const _hoisted_83 = { class: "template-building__column" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Үй / Ғимарат"),
  /*#__PURE__*/_createElementVNode("span", null, "Дом / Здание")
], -1))
const _hoisted_85 = { class: "content__value" }
const _hoisted_86 = { class: "template-building__column" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Пәтер / Кеңсе"),
  /*#__PURE__*/_createElementVNode("span", null, "Кв / Офис")
], -1))
const _hoisted_88 = { class: "content__value" }
const _hoisted_89 = { class: "template-building__column" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Индекс /"),
  /*#__PURE__*/_createElementVNode("span", null, "Индекс")
], -1))
const _hoisted_91 = { class: "content__value" }
const _hoisted_92 = { class: "content__row" }
const _hoisted_93 = { class: "content__block comment block--border-default" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Пікір /"),
  /*#__PURE__*/_createElementVNode("span", null, "Комментарий")
], -1))
const _hoisted_95 = { class: "content__value value--small" }
const _hoisted_96 = { class: "content__block comment block--border-default" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Пікір /"),
  /*#__PURE__*/_createElementVNode("span", null, "Комментарий")
], -1))
const _hoisted_98 = { class: "content__value value--small" }
const _hoisted_99 = { class: "content__row" }
const _hoisted_100 = { class: "content__block contacts block--border-left block--border-right" }
const _hoisted_101 = { class: "contacts__column" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Байланыс телефоны /"),
  /*#__PURE__*/_createElementVNode("span", null, "Контактный телефон")
], -1))
const _hoisted_103 = { class: "content__value value--small" }
const _hoisted_104 = { class: "contacts__column" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Байланысатын тұлғасы /"),
  /*#__PURE__*/_createElementVNode("span", null, "Контактное лицо")
], -1))
const _hoisted_106 = { class: "content__value" }
const _hoisted_107 = { class: "content__block contacts block--border-left block--border-right" }
const _hoisted_108 = { class: "contacts__column" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Байланыс телефоны /"),
  /*#__PURE__*/_createElementVNode("span", null, "Контактный телефон")
], -1))
const _hoisted_110 = { class: "content__value value--small" }
const _hoisted_111 = { class: "contacts__column" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Байланысатын тұлғасы /"),
  /*#__PURE__*/_createElementVNode("span", null, "Контактное лицо")
], -1))
const _hoisted_113 = { class: "content__value" }
const _hoisted_114 = { class: "content__row" }
const _hoisted_115 = { class: "content__row" }
const _hoisted_116 = { class: "content__block parameters block--border-default" }
const _hoisted_117 = { class: "parameters__column" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Орын саны /"),
  /*#__PURE__*/_createElementVNode("span", null, "Количество мест")
], -1))
const _hoisted_119 = { class: "content__value" }
const _hoisted_120 = { class: "parameters__column" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Жүктiң салмағы (кг) /"),
  /*#__PURE__*/_createElementVNode("span", null, "Вес груза (кг)")
], -1))
const _hoisted_122 = { class: "content__value" }
const _hoisted_123 = { class: "parameters__column" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Жүк көлемi (м"),
    /*#__PURE__*/_createElementVNode("sup", null, "3"),
    /*#__PURE__*/_createTextVNode(") /")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Объем груза (м"),
    /*#__PURE__*/_createElementVNode("sup", null, "3"),
    /*#__PURE__*/_createTextVNode(")")
  ])
], -1))
const _hoisted_125 = { class: "content__value" }
const _hoisted_126 = { class: "content__block additional-checkboxes block--border-default" }
const _hoisted_127 = { class: "additional-checkboxes__column" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Жүк тиеушілер /"),
  /*#__PURE__*/_createElementVNode("span", null, "Грузчики")
], -1))
const _hoisted_129 = { class: "additional-checkboxes__column" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Рохля /"),
  /*#__PURE__*/_createElementVNode("span", null, "Рохля")
], -1))
const _hoisted_131 = { class: "additional-checkboxes__column" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Кран /"),
  /*#__PURE__*/_createElementVNode("span", null, "Кран")
], -1))
const _hoisted_133 = { class: "content__row" }
const _hoisted_134 = { class: "content__block payments block--border-default" }
const _hoisted_135 = { class: "payments__column" }
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Төленетiн құн /"),
  /*#__PURE__*/_createElementVNode("span", null, "Сумма к оплате")
], -1))
const _hoisted_137 = { class: "content__value" }
const _hoisted_138 = { class: "payments__column" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Салынған төлем /"),
  /*#__PURE__*/_createElementVNode("span", null, "Наложенный платеж")
], -1))
const _hoisted_140 = { class: "content__value" }
const _hoisted_141 = { class: "payments__column" }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Жарияланған құн /"),
  /*#__PURE__*/_createElementVNode("span", null, "Объявленная стоимость")
], -1))
const _hoisted_143 = { class: "content__value" }
const _hoisted_144 = { class: "content__row" }
const _hoisted_145 = { class: "content__block types block--border-default" }
const _hoisted_146 = {
  key: 0,
  class: "types__column"
}
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Төлем жөнелтуші /"),
  /*#__PURE__*/_createElementVNode("span", null, "Оплата отправителем")
], -1))
const _hoisted_148 = {
  key: 1,
  class: "types__column"
}
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Үшінші тараптың төлемі /"),
  /*#__PURE__*/_createElementVNode("span", null, "Оплата третьим лицом")
], -1))
const _hoisted_150 = {
  key: 2,
  class: "types__column"
}
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Қолма-қол ақшамен /"),
  /*#__PURE__*/_createElementVNode("span", null, "Наличными")
], -1))
const _hoisted_152 = {
  key: 3,
  class: "types__column"
}
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Төлем алушы /"),
  /*#__PURE__*/_createElementVNode("span", null, "Оплата получателем")
], -1))
const _hoisted_154 = {
  key: 4,
  class: "types__column"
}
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Kaspi.kz арқылы /"),
  /*#__PURE__*/_createElementVNode("span", null, "Оплата на kaspi.kz")
], -1))
const _hoisted_156 = { class: "types__column" }
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Шот бойынша аудару /"),
  /*#__PURE__*/_createElementVNode("span", null, "Перечислением по счету")
], -1))
const _hoisted_158 = { class: "content__block template block--border-default" }
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Алушы (Т.А.Ә) /"),
  /*#__PURE__*/_createElementVNode("span", null, "Получатель (Ф.И.О)")
], -1))
const _hoisted_160 = { class: "content__value value--small" }
const _hoisted_161 = { class: "content__row" }
const _hoisted_162 = { class: "content__block template block--border-default" }
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Жүк атауы /"),
  /*#__PURE__*/_createElementVNode("span", null, "Наименование груза")
], -1))
const _hoisted_164 = { class: "content__value" }
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__block template block--border-default" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Алынған (орындар саны) /"),
    /*#__PURE__*/_createElementVNode("span", null, "Получено (количество мест)")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "content__value" })
], -1))
const _hoisted_166 = { class: "content__row" }
const _hoisted_167 = { class: "content__block additional-checkboxes block--border-default" }
const _hoisted_168 = { class: "additional-checkboxes__column" }
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Жүк тиеушілер /"),
  /*#__PURE__*/_createElementVNode("span", null, "Грузчики")
], -1))
const _hoisted_170 = { class: "additional-checkboxes__column" }
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Рохля /"),
  /*#__PURE__*/_createElementVNode("span", null, "Рохля")
], -1))
const _hoisted_172 = { class: "additional-checkboxes__column" }
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Кран /"),
  /*#__PURE__*/_createElementVNode("span", null, "Кран")
], -1))
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__block template block--border-default" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Жеткізу бойынша ескертпе /"),
    /*#__PURE__*/_createElementVNode("span", null, "Примечания по доставке")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "content__value" })
], -1))
const _hoisted_175 = { class: "content__row" }
const _hoisted_176 = {
  class: "content__block",
  style: {"padding":"0"}
}
const _hoisted_177 = { class: "content__block additional-checkboxes block--border-left block--border-right" }
const _hoisted_178 = { class: "additional-checkboxes__column" }
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Жүк жәшігі /"),
  /*#__PURE__*/_createElementVNode("span", null, "Обрешетка")
], -1))
const _hoisted_180 = { class: "additional-checkboxes__column" }
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Жұмсақ орау /"),
  /*#__PURE__*/_createElementVNode("span", null, "Мягкая упаковка")
], -1))
const _hoisted_182 = { class: "additional-checkboxes__column" }
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Паллетеу /"),
  /*#__PURE__*/_createElementVNode("span", null, "Паллетирование")
], -1))
const _hoisted_184 = /*#__PURE__*/_createStaticVNode("<div class=\"content__block receiver-sign block--border-default\" data-v-3e8d5982><div class=\"receiver-sign__columns\" data-v-3e8d5982><div class=\"columns__column\" data-v-3e8d5982><div class=\"content__label\" data-v-3e8d5982><span data-v-3e8d5982>Қолы /</span><span data-v-3e8d5982>Подпись</span></div><span class=\"content__value\" data-v-3e8d5982></span></div><div class=\"columns__column\" data-v-3e8d5982><div class=\"content__label\" data-v-3e8d5982><span data-v-3e8d5982>Күні /</span><span data-v-3e8d5982>Дата</span></div><span class=\"content__value\" data-v-3e8d5982></span></div><div class=\"columns__column\" data-v-3e8d5982><div class=\"content__label\" data-v-3e8d5982><span data-v-3e8d5982>Уақыты /</span><span data-v-3e8d5982>Время</span></div><span class=\"content__value\" data-v-3e8d5982></span></div></div><p class=\"receiver-sign__hint\" data-v-3e8d5982> Жөнелтімді толық көлемде алғанымды, «Spark Логистика» ЖШС-не шағымдарым жоқ екенін өз қолыммен растаймын. / Своей подписью подтверждаю, что отправление получено в полном объеме, претензий к ТОО &quot;Spark Логистика&quot; не имею. </p></div>", 1)
const _hoisted_185 = { class: "content__row" }
const _hoisted_186 = { class: "content__block block--border-default note" }
const _hoisted_187 = { class: "note-block" }
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Жіберу бойынша ескертпе /"),
  /*#__PURE__*/_createElementVNode("span", null, "Примечание по отправке")
], -1))
const _hoisted_189 = { class: "content__value" }
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "note-block",
  style: {"min-width":"120px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Орын саны /"),
    /*#__PURE__*/_createElementVNode("span", null, "Количество мест")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "content__value" })
], -1))
const _hoisted_191 = /*#__PURE__*/_createStaticVNode("<div class=\"content__block courier-sign block--border-default\" data-v-3e8d5982><p class=\"courier-sign__hint\" data-v-3e8d5982> Курьермен толтырылады. Барлық жолдарды толтыру міндетті/ Заполняется Курьером. Все поля обязательны к заполнению </p><div class=\"courier-sign__columns\" data-v-3e8d5982><div class=\"columns__column\" data-v-3e8d5982><div class=\"content__label\" data-v-3e8d5982><span data-v-3e8d5982>Жеткiзушi курьер /</span><span data-v-3e8d5982>Курьер доставки</span></div><span class=\"content__value\" data-v-3e8d5982></span></div><div class=\"columns__column\" data-v-3e8d5982><div class=\"content__label\" data-v-3e8d5982><span data-v-3e8d5982>Күні /</span><span data-v-3e8d5982>Дата</span></div><span class=\"content__value\" data-v-3e8d5982></span></div><div class=\"columns__column\" data-v-3e8d5982><div class=\"content__label\" data-v-3e8d5982><span data-v-3e8d5982>Уақыты /</span><span data-v-3e8d5982>Время</span></div><span class=\"content__value\" data-v-3e8d5982></span></div></div></div>", 1)
const _hoisted_192 = { class: "content__row" }
const _hoisted_193 = {
  class: "content__block",
  style: {"padding":"0","display":"grid"}
}
const _hoisted_194 = { class: "content__block receiver-sign block--border-default" }
const _hoisted_195 = { class: "receiver-sign__columns" }
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "columns__column" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Жіберуші қолы /"),
    /*#__PURE__*/_createElementVNode("span", null, "Подпись отправителя")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "content__value" })
], -1))
const _hoisted_197 = { class: "columns__column" }
const _hoisted_198 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Күні /"),
  /*#__PURE__*/_createElementVNode("span", null, "Дата")
], -1))
const _hoisted_199 = { class: "content__value" }
const _hoisted_200 = { class: "columns__column" }
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__label" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"white-space":"nowrap"} }, "Уақыты /"),
  /*#__PURE__*/_createElementVNode("span", null, "Время")
], -1))
const _hoisted_202 = {
  class: "content__value",
  style: {"white-space":"nowrap"}
}
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "receiver-sign__hint" }, " Қолымды қою арқылы офертаның шарттарымен (жүк құжаттың артқы жағынан немесе www.spark.kz сайтында қараңыз) танысқанымды және олармен толық келісетінімді растаймын./ Настоящей подписью подтверждаю, что я ознакомлен(а) и полностью согласен(а) с условиями оферты (см. на обратной стороне накладной или на сайте www.spark.kz) ", -1))
const _hoisted_204 = /*#__PURE__*/_createStaticVNode("<div class=\"content__block courier-sign block--border-default\" data-v-3e8d5982><p class=\"courier-sign__hint\" data-v-3e8d5982> Курьермен толтырылады. Барлық жолдарды толтыру міндетті/ Заполняется Курьером. Все поля обязательны к заполнению </p><div class=\"courier-sign__columns\" data-v-3e8d5982><div class=\"columns__column\" data-v-3e8d5982><div class=\"content__label\" data-v-3e8d5982><span data-v-3e8d5982>Алушы курьер /</span><span data-v-3e8d5982>Курьер забора</span></div><span class=\"content__value\" data-v-3e8d5982></span></div><div class=\"columns__column\" data-v-3e8d5982><div class=\"content__label\" data-v-3e8d5982><span data-v-3e8d5982>Күні /</span><span data-v-3e8d5982>Дата</span></div><span class=\"content__value\" data-v-3e8d5982></span></div><div class=\"columns__column\" data-v-3e8d5982><div class=\"content__label\" data-v-3e8d5982><span data-v-3e8d5982>Уақыты /</span><span data-v-3e8d5982>Время</span></div><span class=\"content__value\" data-v-3e8d5982></span></div></div></div>", 1)
const _hoisted_205 = {
  class: "content__block end",
  style: {"padding":"0","margin-top":"4px"}
}
const _hoisted_206 = { class: "content__block qr block--border-full" }
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content__label",
  style: {"font-size":"6px"}
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Көпшілік офертасы /"),
  /*#__PURE__*/_createElementVNode("span", null, "Публичная оферта")
], -1))
const _hoisted_208 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content__label",
  style: {"font-size":"6px"}
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Орауға қойылатын талаптар /"),
  /*#__PURE__*/_createElementVNode("span", null, "Требования к упаковке")
], -1))
const _hoisted_209 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "end__contacts" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Контакты:"),
  /*#__PURE__*/_createElementVNode("p", null, "+7 707 345 44 45"),
  /*#__PURE__*/_createElementVNode("p", null, "+7 747 094 18 30"),
  /*#__PURE__*/_createElementVNode("p", null, "mail@spark.kz"),
  /*#__PURE__*/_createElementVNode("p", null, "Spark.kz")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_invoice_document_checkbox = _resolveComponent("invoice-document-checkbox")!
  const _component_invoice_document_header = _resolveComponent("invoice-document-header")!
  const _component_vue_qrcode = _resolveComponent("vue-qrcode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_ctx.senderTerminalLetters)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.senderTerminalLetters[0]), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_ctx.senderTerminalLetters)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.senderTerminalLetters[1]), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              (_ctx.senderTerminalLetters)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.senderTerminalLetters[2]), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              (_ctx.receiverTerminalLetters)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.receiverTerminalLetters[0]), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              (_ctx.receiverTerminalLetters)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.receiverTerminalLetters[1]), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_16, [
              (_ctx.receiverTerminalLetters)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.receiverTerminalLetters[2]), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("img", {
            id: 'barcode_' + _ctx.invoice.invoice_number,
            class: "barcode",
            "data-value": _ctx.invoice.invoice_number,
            src: `data:image/png;base64, ${_ctx.invoice.barcode_html}`,
            "data-format": "CODE39",
            "data-fontSize": "32px"
          }, null, 8, _hoisted_19)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.invoice.invoice_number), 1),
          _hoisted_22
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("span", _hoisted_26, [
            (_ctx.invoice.order_number)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.invoice.order_number), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" - ")
                ], 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("span", _hoisted_29, [
            (_ctx.invoice.dop_invoice_number)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.invoice.dop_invoice_number), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" - ")
                ], 64))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: _ctx.invoice.shipment_type_id === 1
            }, null, 8, ["checked"]),
            _hoisted_33
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: Boolean(_ctx.invoice.is_dangerous)
            }, null, 8, ["checked"]),
            _hoisted_35
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: _ctx.invoice.shipment_type_id === 2
            }, null, 8, ["checked"]),
            _hoisted_37
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: Boolean(_ctx.invoice.temperature_regime)
            }, null, 8, ["checked"]),
            _hoisted_39
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createVNode(_component_invoice_document_checkbox, { checked: false }),
            _hoisted_41
          ]),
          _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.invoice.temperature_regime ? _ctx.invoice.temperature_regime.title : ''), 1),
          _createElementVNode("div", _hoisted_43, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: _ctx.invoice.has_battery
            }, null, 8, ["checked"]),
            _hoisted_44
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: _ctx.invoice.has_auto_parts
            }, null, 8, ["checked"]),
            _hoisted_46
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_47, [
      _createElementVNode("div", _hoisted_48, [
        _createVNode(_component_invoice_document_header, {
          number: 1,
          title: "Жіберушінің ақпараттары / ДАННЫЕ ОТПРАВИТЕЛЯ"
        }),
        _createVNode(_component_invoice_document_header, {
          number: 4,
          title: "Алушының ақпараттары / ДАННЫЕ ПОЛУЧАТЕЛЯ"
        })
      ]),
      _createElementVNode("div", _hoisted_49, [
        _createElementVNode("div", _hoisted_50, [
          _hoisted_51,
          _createElementVNode("span", _hoisted_52, [
            (_ctx.invoice.sender.title)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.invoice.sender.title), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" не указано ")
                ], 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_53, [
          _hoisted_54,
          _createElementVNode("span", _hoisted_55, [
            (_ctx.invoice.receiver.title)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.invoice.receiver.title), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" не указано ")
                ], 64))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_56, [
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _hoisted_59,
            _createElementVNode("span", _hoisted_60, [
              (_ctx.invoice.sender.full_address)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.sender.full_address), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" не указано ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_61, [
            _hoisted_62,
            _createElementVNode("span", _hoisted_63, [
              (_ctx.invoice.sender.sectorName)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.sender.sectorName), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" не указано ")
                  ], 64))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _hoisted_66,
            _createElementVNode("span", _hoisted_67, [
              (_ctx.invoice.receiver.full_address)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.receiver.full_address), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" не указано ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_68, [
            _hoisted_69,
            _createElementVNode("span", _hoisted_70, [
              (_ctx.invoice.receiver.sectorName)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.receiver.sectorName), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" не указано ")
                  ], 64))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_71, [
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("div", _hoisted_73, [
            _hoisted_74,
            _createElementVNode("span", _hoisted_75, [
              (_ctx.invoice.sender.house)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.sender.house), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" не указано ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_76, [
            _hoisted_77,
            _createElementVNode("span", _hoisted_78, [
              (_ctx.invoice.sender.office)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.sender.office), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" не указано ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_79, [
            _hoisted_80,
            _createElementVNode("span", _hoisted_81, [
              (_ctx.invoice.sender.index)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.sender.index), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" не указ. ")
                  ], 64))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_82, [
          _createElementVNode("div", _hoisted_83, [
            _hoisted_84,
            _createElementVNode("span", _hoisted_85, [
              (_ctx.invoice.receiver.house)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.receiver.house), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" не указано ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_86, [
            _hoisted_87,
            _createElementVNode("span", _hoisted_88, [
              (_ctx.invoice.receiver.office)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.receiver.office), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" не указано ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_89, [
            _hoisted_90,
            _createElementVNode("span", _hoisted_91, [
              (_ctx.invoice.receiver.index)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.receiver.index), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" не указ. ")
                  ], 64))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_92, [
        _createElementVNode("div", _hoisted_93, [
          _hoisted_94,
          _createElementVNode("span", _hoisted_95, [
            (_ctx.invoice.sender.comment)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.invoice.sender.comment), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" не указано ")
                ], 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_96, [
          _hoisted_97,
          _createElementVNode("span", _hoisted_98, [
            (_ctx.invoice.receiver.comment)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.invoice.receiver.comment), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" не указано ")
                ], 64))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_99, [
        _createElementVNode("div", _hoisted_100, [
          _createElementVNode("div", _hoisted_101, [
            _hoisted_102,
            _createElementVNode("span", _hoisted_103, [
              (_ctx.invoice.sender.phone && _ctx.invoice.sender.additional_phone)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.sender.phone) + ", " + _toDisplayString(_ctx.invoice.sender.additional_phone), 1)
                  ], 64))
                : (_ctx.invoice.sender.phone && !_ctx.invoice.sender.additional_phone)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.invoice.sender.phone), 1)
                    ], 64))
                  : (!_ctx.invoice.sender.phone && _ctx.invoice.sender.additional_phone)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(_toDisplayString(_ctx.invoice.sender.additional_phone), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createTextVNode(" не указано ")
                      ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_104, [
            _hoisted_105,
            _createElementVNode("span", _hoisted_106, [
              (_ctx.invoice.sender.full_name)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.sender.full_name), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" не указано ")
                  ], 64))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_107, [
          _createElementVNode("div", _hoisted_108, [
            _hoisted_109,
            _createElementVNode("span", _hoisted_110, [
              (_ctx.invoice.receiver.phone && _ctx.invoice.receiver.additional_phone)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.receiver.phone) + ", " + _toDisplayString(_ctx.invoice.receiver.additional_phone), 1)
                  ], 64))
                : (
                                    _ctx.invoice.receiver.phone && !_ctx.invoice.receiver.additional_phone
                                )
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.invoice.receiver.phone), 1)
                    ], 64))
                  : (
                                    !_ctx.invoice.receiver.phone && _ctx.invoice.receiver.additional_phone
                                )
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(_toDisplayString(_ctx.invoice.receiver.additional_phone), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createTextVNode(" не указано ")
                      ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_111, [
            _hoisted_112,
            _createElementVNode("span", _hoisted_113, [
              (_ctx.invoice.receiver.full_name)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.receiver.full_name), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" не указано ")
                  ], 64))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_114, [
        _createVNode(_component_invoice_document_header, {
          number: 2,
          title: "қосымша ақпарат / Дополнительная  информация"
        }),
        _createVNode(_component_invoice_document_header, {
          number: 5,
          title: "қосымша ақпарат / Дополнительная  информация"
        })
      ]),
      _createElementVNode("div", _hoisted_115, [
        _createElementVNode("div", _hoisted_116, [
          _createElementVNode("div", _hoisted_117, [
            _hoisted_118,
            _createElementVNode("span", _hoisted_119, [
              (_ctx.invoice.places)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.places), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" не указано ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_120, [
            _hoisted_121,
            _createElementVNode("span", _hoisted_122, [
              (_ctx.invoice.weight)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.weight), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" не указано ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_123, [
            _hoisted_124,
            _createElementVNode("span", _hoisted_125, [
              (_ctx.invoice.volume)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.volume), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" не указано ")
                  ], 64))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_126, [
          _createElementVNode("div", _hoisted_127, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: _ctx.isReceiverHaveAdditionalService('loader')
            }, null, 8, ["checked"]),
            _hoisted_128
          ]),
          _createElementVNode("div", _hoisted_129, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: _ctx.isReceiverHaveAdditionalService('hydraulic_trolley')
            }, null, 8, ["checked"]),
            _hoisted_130
          ]),
          _createElementVNode("div", _hoisted_131, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: _ctx.isReceiverHaveAdditionalService('crane')
            }, null, 8, ["checked"]),
            _hoisted_132
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_133, [
        _createElementVNode("div", _hoisted_134, [
          _createElementVNode("div", _hoisted_135, [
            _hoisted_136,
            _createElementVNode("span", _hoisted_137, [
              (_ctx.invoice.cash_sum)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.cash_sum), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" не указано ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_138, [
            _hoisted_139,
            _createElementVNode("span", _hoisted_140, [
              (_ctx.invoice.cod_payment)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.cod_payment), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" не указано ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_141, [
            _hoisted_142,
            _createElementVNode("span", _hoisted_143, [
              (_ctx.invoice.declared_price)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.declared_price), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" не указано ")
                  ], 64))
            ])
          ])
        ]),
        _createVNode(_component_invoice_document_header, {
          number: 6,
          title: "АЛУШЫ / ПОЛУЧАТЕЛЬ"
        })
      ]),
      _createElementVNode("div", _hoisted_144, [
        _createElementVNode("div", _hoisted_145, [
          (_ctx.invoice.payment_type_id === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                _createVNode(_component_invoice_document_checkbox, {
                  checked: _ctx.invoice.payment_type_id === 1
                }, null, 8, ["checked"]),
                _hoisted_147
              ]))
            : _createCommentVNode("", true),
          (_ctx.invoice.payment_type_id === 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                _createVNode(_component_invoice_document_checkbox, {
                  checked: _ctx.invoice.payment_type_id === 3
                }, null, 8, ["checked"]),
                _hoisted_149
              ]))
            : _createCommentVNode("", true),
          (_ctx.invoice.payment_method_id === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
                _createVNode(_component_invoice_document_checkbox, {
                  checked: _ctx.invoice.payment_method_id === 2
                }, null, 8, ["checked"]),
                _hoisted_151
              ]))
            : _createCommentVNode("", true),
          (_ctx.invoice.payment_type_id === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_152, [
                _createVNode(_component_invoice_document_checkbox, {
                  checked: _ctx.invoice.payment_type_id === 2
                }, null, 8, ["checked"]),
                _hoisted_153
              ]))
            : _createCommentVNode("", true),
          (_ctx.invoice.payment_method_id === 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                _createVNode(_component_invoice_document_checkbox, {
                  checked: _ctx.invoice.payment_method_id === 4
                }, null, 8, ["checked"]),
                _hoisted_155
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_156, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: _ctx.invoice.payment_method_id === 3
            }, null, 8, ["checked"]),
            _hoisted_157
          ])
        ]),
        _createElementVNode("div", _hoisted_158, [
          _hoisted_159,
          _createElementVNode("span", _hoisted_160, [
            (_ctx.invoice.receiver.full_name)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.invoice.receiver.full_name), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" не указано ")
                ], 64))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_161, [
        _createElementVNode("div", _hoisted_162, [
          _hoisted_163,
          _createElementVNode("span", _hoisted_164, _toDisplayString(_ctx.invoice.product_name), 1)
        ]),
        _hoisted_165
      ]),
      _createElementVNode("div", _hoisted_166, [
        _createElementVNode("div", _hoisted_167, [
          _createElementVNode("div", _hoisted_168, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: _ctx.isSenderHaveAdditionalService('loader')
            }, null, 8, ["checked"]),
            _hoisted_169
          ]),
          _createElementVNode("div", _hoisted_170, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: _ctx.isSenderHaveAdditionalService('hydraulic_trolley')
            }, null, 8, ["checked"]),
            _hoisted_171
          ]),
          _createElementVNode("div", _hoisted_172, [
            _createVNode(_component_invoice_document_checkbox, {
              checked: _ctx.isSenderHaveAdditionalService('crane')
            }, null, 8, ["checked"]),
            _hoisted_173
          ])
        ]),
        _hoisted_174
      ]),
      _createElementVNode("div", _hoisted_175, [
        _createElementVNode("div", _hoisted_176, [
          _createElementVNode("div", _hoisted_177, [
            _createElementVNode("div", _hoisted_178, [
              _createVNode(_component_invoice_document_checkbox, {
                checked: _ctx.isReceiverHaveAdditionalService('grid')
              }, null, 8, ["checked"]),
              _hoisted_179
            ]),
            _createElementVNode("div", _hoisted_180, [
              _createVNode(_component_invoice_document_checkbox, {
                checked: _ctx.isReceiverHaveAdditionalService('soft_package')
              }, null, 8, ["checked"]),
              _hoisted_181
            ]),
            _createElementVNode("div", _hoisted_182, [
              _createVNode(_component_invoice_document_checkbox, {
                checked: _ctx.isReceiverHaveAdditionalService('pallet')
              }, null, 8, ["checked"]),
              _hoisted_183
            ])
          ]),
          _createVNode(_component_invoice_document_header, {
            number: 3,
            title: "Жіберуші / ОТПРАВИТЕЛЬ"
          })
        ]),
        _hoisted_184
      ]),
      _createElementVNode("div", _hoisted_185, [
        _createElementVNode("div", _hoisted_186, [
          _createElementVNode("div", _hoisted_187, [
            _hoisted_188,
            _createElementVNode("span", _hoisted_189, [
              (_ctx.invoice.annotation)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.annotation), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" не указано ")
                  ], 64))
            ])
          ]),
          _hoisted_190
        ]),
        _hoisted_191
      ]),
      _createElementVNode("div", _hoisted_192, [
        _createElementVNode("div", _hoisted_193, [
          _createElementVNode("div", _hoisted_194, [
            _createElementVNode("div", _hoisted_195, [
              _hoisted_196,
              _createElementVNode("div", _hoisted_197, [
                _hoisted_198,
                _createElementVNode("span", _hoisted_199, _toDisplayString(_ctx.invoice.take_date), 1)
              ]),
              _createElementVNode("div", _hoisted_200, [
                _hoisted_201,
                _createElementVNode("span", _hoisted_202, _toDisplayString(_ctx.invoice.period), 1)
              ])
            ]),
            _hoisted_203
          ]),
          _hoisted_204
        ]),
        _createElementVNode("div", _hoisted_205, [
          _createElementVNode("div", _hoisted_206, [
            _hoisted_207,
            _createVNode(_component_vue_qrcode, {
              value: _ctx.PUBLIC_OFFER_LINK,
              options: { width: 70 }
            }, null, 8, ["value"]),
            _hoisted_208,
            _createVNode(_component_vue_qrcode, {
              value: _ctx.PACKING_REQUIREMENTS_LINK,
              options: { width: 70 }
            }, null, 8, ["value"])
          ]),
          _hoisted_209
        ])
      ])
    ])
  ]))
}